import { ActionCreator } from 'app/redux/ActionCreator';
import { ActionTypes, IAdminAction, IUserState } from 'app/redux/Admin/reducer';

class AdminActionCreator extends ActionCreator<IUserState, IAdminAction> {
  getUsers(apiKey: string) {
    return this.dispatchAsync((getState) => {
      return new Promise((resolve, reject) => {
        fetch('https://kbqk6mximj.execute-api.us-east-1.amazonaws.com/Test/downloadfile', {
          method: 'POST',
          headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json',
            Authorization: apiKey,
          },
        })
          .then((result) => {
            result
              .json()
              .then((parsedJson) => {
                const resource: IUserState = { username: '', lastname: '', firstname: '', email: '', error: null };
                const action = { type: ActionTypes.LISTUSERS, resource };
                resolve(action);
              })
              .catch((error) => {
                const users: IUserState = { username: '', lastname: '', firstname: '', email: '', error };
                const action = { type: ActionTypes.LISTUSERS, users };
                reject(action);
              });
          })
          .catch((error) => {
            const users: IUserState = { username: '', lastname: '', firstname: '', email: '', error };
            const action = { type: ActionTypes.LISTUSERS, users };
            reject(action);
          });
      });
    });
  }

  addUser(username: string, password: string, firstname: string, lastname: string, email: string, apiKey: string, accessToken: string) {
    return this.dispatchAsync((getState) => {
      return new Promise((resolve, reject) => {
        fetch('https://kbqk6mximj.execute-api.us-east-1.amazonaws.com/Test/adduser', {
          method: 'POST',
          headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json',
            Authorization: apiKey,
          },
          body: JSON.stringify({
            username,
            password,
            firstname,
            lastname,
            email,
          }),
        })
          .then((result) => {
            result
              .json()
              .then((parsedJson) => {
                const users: IUserState = { username, lastname, firstname, email, error: null };
                const action = { type: ActionTypes.ADDUSER, users };
                resolve(action);
              })
              .catch((error) => {
                const users: IUserState = { username: '', lastname: '', firstname: '', email: '', error };
                const action = { type: ActionTypes.ADDUSER, users };
                reject(action);
              });
          })
          .catch((error) => {
            const users: IUserState = { username: '', lastname: '', firstname: '', email: '', error };
            const action = { type: ActionTypes.ADDUSER, users };
            reject(action);
          });
      });
    });
  }

  deleteUser(userName: string, firstname: string, lastname: string, email: string, apiKey: string, accessToken: string) {
    return this.dispatchAsync((getState) => {
      const rbody = { action: 'deleteUser', request: { userName: userName } };
      return new Promise((resolve, reject) => {
        fetch('https://kbqk6mximj.execute-api.us-east-1.amazonaws.com/Test/foundationmark-requests', {
          // todo: endpoint TBD
          method: 'POST',
          headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json',
            Authorization: apiKey,
          },
          body: JSON.stringify(rbody),
        })
          .then((result) => {
            const users: IUserState = { username: userName, firstname, lastname, email, error: null };
            const action = { type: ActionTypes.DELETEUSER, users };
            resolve(action);
          })
          .catch((error) => {
            const users: IUserState = { username: '', lastname: '', firstname: '', email: '', error };
            const action = { type: ActionTypes.DELETEUSER, users };
            reject(action);
          });
      });
    });
  }
}

const AdminAction = new AdminActionCreator();

export { AdminAction, AdminActionCreator };



// WEBPACK FOOTER //
// ./src/app/redux/Admin/actions/index.ts